import { useUserSettingsStore } from '@/stores/user-settings.store';

import { useSubscriptionStore } from '@/stores/subscription.store';

export class Storage {
    constructor (namespaced = false, crossUI = false) {
        this.namespaced = namespaced;
        this.crossUI = crossUI;
    }

    async get (key, reFetch = false) {
        await useUserSettingsStore().loadOne({
            name: key,
            namespaced: this.namespaced,
            crossUI: this.crossUI,
            reFetch,
        });

        let name = key;
        if (this.namespaced) {
            name = this.crossUI
                ? `${useSubscriptionStore().active.id}::${key}`
                : `${key}--${useSubscriptionStore().active.id}`;
        }

        return useUserSettingsStore().map[name];
    }

    async set (key, value, force = false) {
        await useUserSettingsStore().update({
            name: key,
            value,
            namespaced: this.namespaced,
            force,
            crossUI: this.crossUI,
        });
    }

    async remove (key) {
        await useUserSettingsStore().remove({ name: key, namespaced: this.namespaced, crossUI: this.crossUI });
    }
}

export const UserStorage = new Storage();

export const PerSubscriptionUserStorage = new Storage(true);
